const AdminBusinesses = () => {
  return (
    <>
      <h1>Businesses</h1>
      <p>Review and manage business profiles.</p>
    </>
  );
};

export default AdminBusinesses;
